import * as React from "react";
import type { SVGProps } from "react";

const SvgChevronDownSlim = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={21.818}
        height={60}
        {...props}
    >
        <path
            fill="#737373"
            d="M6.232 30 21.437 4.131a2.759 2.759 0 0 0-.916-3.742 2.641 2.641 0 0 0-3.666.935L0 30l16.855 28.676a2.641 2.641 0 0 0 3.666.935 2.759 2.759 0 0 0 .916-3.742Z"
        />
    </svg>
);
export default SvgChevronDownSlim;
